export const PLURAL_CORRECTION_TEXT = 'Corrigez les erreurs suivantes';
export const SINGULAR_CORRECTION_TEXT = "Corrigez l'erreur suivante";
